/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { Input } from '../../../components';
import { Constants, getUpdatedState } from '../../../utils';
import { OrdersService } from '../../../services';
import { SearchIcon } from '../../../assets/icons';

const ModalReassignment = ({ item, onClose, onSuccess }) => {
  const { data, filters, isLoading, onChange, submit } = useForm({ item, onClose, onSuccess });

  return (
    <div className="w-[28rem] px-4 pb-6 bg-white rounded-2xl shadow-xl overflow-hidden max-h-[90vh] overflow-y-auto">
      <div className="flex items-center justify-between py-4">
        <h2 className="text-lg font-bold text-text">Conductores disponibles</h2>
        <button
          type="button"
          className="p-1.5 rounded-full hover:bg-gray5 transition-colors"
          onClick={onClose}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <Input
        placeholder="Buscar"
        value={filters.search}
        onValueChange={v => onChange('search', v)}
        prepend={
          <img src={SearchIcon} className="w-4 h-4" alt="" />
        }
      />

      <div className="flex justify-between items-center my-6">
        <p className="text-lg font-semibold">Seleccione conductor</p>
        <p className="bg-[#000] text-white px-3 py-1 rounded-full">{ data.length } disponible</p>
      </div>

      {data.map((item, index) => (
        <div
          className="py-2 flex gap-2 items-center cursor-pointer border-b border-gray6"
          onClick={() => submit(item.id)}
        >
          <div className="w-2 h-2 bg-green rounded-full" />
          <p className="text-lg">
            <span className="font-semibold">{ item.person?.fullName } - </span>
            <span className="text-orange">{ item.person?.document }</span>
          </p>
        </div>
      ))}

      {!data.length && (
        <p className="text-center text-default py-8">No hay conductores disponibles</p>
      )}

      {(!data.length && isLoading) && (
        <p className="text-center text-default py-8">Cargando...</p>
      )}
    </div>
  );
};

const useForm = ({ item, onClose, onSuccess }) => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    level_id: Constants.LEVELS.DRIVER,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const debounceRef = useRef(null);

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await OrdersService.moderator.findUsers(payload);
      const { data } = response;

      setData(data);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => fetchData(), 300);
  }

  const submit = async (id) => {
    setCanFetch(false);

    try {
      const payload = {
        order_id: item.id,
        driver_id: id,
      };
      await OrdersService.moderator.reassignment(payload);
      toast.success('Se ha reasignado el conductor con éxito');
      onSuccess?.();
      onClose?.();

    } catch (error) {
      console.log(error)
    } finally {
      setCanFetch(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    filters,
    isLoading: !canFetch,
    onChange,
    search: fetchData,
    submit,
  }
};

export default ModalReassignment;
